export default "__VITE_ASSET__dd46f625__"